import { useIntl } from 'react-intl';

import { ApiWorkflowDialogMessages } from '@verantos-dev/shared-components';

export const useRenameCohortModalStrings = () => {
  const intl = useIntl();
  const contentMessages = {
    title: intl.formatMessage({ id: 'cohortsList.renameCohortModal.title' }),
    inputLabel: intl.formatMessage({ id: 'cohortsList.createCohortModal.cohortName.label' }),
    inputPlaceholder: intl.formatMessage({
      id: 'cohortsList.createCohortModal.cohortName.placeholder',
    }),
    maxCharacterErrorMsg: intl.formatMessage({
      id: 'cohortsList.createCohortModal.maxCharacterErrorMsg',
    }),
  };

  const dialogMessages: ApiWorkflowDialogMessages = {
    loadingCancelButtonText: intl.formatMessage({
      id: 'cohortsList.createCohortModal.cancelButton',
    }),
    loadingSaveButtonText: intl.formatMessage({
      id: 'cohortsList.renameCohortModal.deleteButton',
    }),
    entryCancelButtonText: intl.formatMessage({
      id: 'cohortsList.createCohortModal.cancelButton',
    }),
    entrySaveButtonText: intl.formatMessage({ id: 'cohortsList.renameCohortModal.deleteButton' }),
    submittingCancelButtonText: intl.formatMessage({
      id: 'cohortsList.createCohortModal.cancelButton',
    }),
    submittingSaveButtonText: intl.formatMessage({
      id: 'cohortsList.renameCohortModal.submitting',
    }),
    successCloseButtonText: intl.formatMessage({
      id: 'cohortsList.createCohortModal.closeButton',
    }),
    submittingErrorTitle: intl.formatMessage({
      id: 'cohortsList.createCohortModal.submittingError',
    }),
    successTitle: intl.formatMessage({ id: 'cohortsList.createCohortModal.success.title' }),
    successText: intl.formatMessage({ id: 'cohortsList.renameCohortModal.success.text' }),
  };

  return {
    dialogMessages,
    contentMessages,
  };
};
